import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { ShippingMethodCode } from '../../enums/shipping-method-code';
import { Guid } from '@web/utils';
import { ShippingMethodPropertyResponse } from './shipping-method-property.response';

@jsonObject
export class ShippingMethodResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly category!: string;

  @jsonMember(String)
  public readonly description!: string;

  @jsonMember(String)
  public readonly code!: ShippingMethodCode;

  @jsonArrayMember(ShippingMethodPropertyResponse)
  public readonly properties!: ShippingMethodPropertyResponse[];
}
